import React, { CSSProperties, useEffect, useState } from 'react';

import socket from 'domain/services/socketIoTemp';
import { cleanChatRoom } from 'redux/chat/actions';
import { getActiveChat, getAllMessages } from 'redux/chat/selectors';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { changeCurrentScreen } from 'redux/mobile_screen_flow/mobile_screen_flow.slice';
import useDeviceDetect from 'hooks/useDeviceDetect';
import { setActiveChat } from 'redux/chat/specific_chat.slices';
import useQuery from 'hooks/useQuery';

import ChatCard from '../ChatCard/ChatCard';
import Message from './components/Messages/Messages';
import ChatInput from './components/chatInput/ChatInput';

import 'emoji-mart/css/emoji-mart.css';
import './ChatView.scoped.scss';

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
  tooltipElement?: React.ReactNode;
}

const ChatView: React.FC<Props> = ({ style }) => {
  const dispatch = useAppDispatch();
  const activeChat = useAppSelector(getActiveChat);
  const messages = useAppSelector(getAllMessages);
  const { isMobile } = useDeviceDetect();
  const [isOnEdit, setIsOnEdit] = useState(false);

  const query = useQuery();
  const chatId = query.get('id');

  useEffect(() => {
    return () => {
      if (activeChat && activeChat.id !== chatId) {
        socket.emit('leaveChat', activeChat.id);
        dispatch(cleanChatRoom());
      }
      dispatch(setActiveChat(''));
    };
  }, [activeChat]);

  useEffect(() => {
    return () => {
      if (!isMobile) {
        dispatch(changeCurrentScreen('pinned'));
      }
    };
  }, []);

  return (
    <div className="chat-view-container" style={style}>
      <ChatCard>
        <ChatCard.Header
          title={activeChat && activeChat.title}
          members={activeChat?.participants?.length}
          backButton={isMobile}
          goToScreen={() => dispatch(changeCurrentScreen('list'))}
          pinButton={true}
          goToPinScreen={() => dispatch(changeCurrentScreen('pinned'))}
          membersButton={true}
          goToMembersScreen={() => dispatch(changeCurrentScreen('members'))}
        />
        <ChatCard.Body>
          <Message isOnEdit={isOnEdit} setIsOnEdit={setIsOnEdit} messages={messages} />
          <ChatInput setIsOnEdit={setIsOnEdit} />
        </ChatCard.Body>
      </ChatCard>
    </div>
  );
};

export default ChatView;
